<template>
  <!--  {{ allUserVip }}-->
  <!--  {{ currentMember }}-->
  <div v-if="currentMember" :class="currentMember?.class_check">
    <div class="info">
      <div class="title_type">
        {{ $t(`${productSortSwitch(currentMember?.productSort)}`) }}
      </div>
      <div class="des" v-if="currentMember?.productSort===5">
        {{ $t('join.vip') + ',' + $t('join.vip.des') }}
      </div>
      <div v-else class="des">
        <span>{{ $t('common.endtime') + ':' }}</span>
        <span style="margin-left: 10px">{{
            userInfo?.vipExpireDate && userInfo?.isVip !== 0 ? userInfo?.vipExpireDate : $t('common.yjmf')
          }}</span>
      </div>
    </div>
    <div v-if="currentMember?.productSort !== 5 && userInfo?.vipExpireDate && userInfo?.isVip!==0" class="btn"
         @click="handleRenewNow(currentMember)">{{
        $t('common.ph16')
      }}
    </div>
  </div>
</template>

<script setup>
import {computed, ref} from 'vue'
import {useRouter} from "vue-router";
import {useStore} from "vuex";
import {productSortSwitch} from "@/utils/util";

const store = useStore()
const router = useRouter()
const {memberType} = defineProps({
  memberType: {
    type: Number,
    default: 1
  }
})
const userInfo = computed(() => store.state.user.userInfo)
// 会员类型列表
const allUserVip = computed(() => store.state.buystorage.allUserVip.map((item, index) => ({
  ...item,
  class_check: `vip_type_${index + 1}`
})))
// 当前用户会员类型对象
const currentMember = computed(() =>
    allUserVip.value.find(item => item.productSort === memberType)
)

// 点击续费
function handleRenewNow() {
  console.log('点击立即续费')
  const {id, productSort} = currentMember.value
  router.push({path: '/personal/buystorage', query: {indexId: id, productSort: productSort, type: 2}})
  // 可在此添加续费逻辑，如跳转、调用支付等
}
</script>

<style scoped lang="less">
.title_type {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #202020;
}

.des {
  margin-top: 10px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #202020;
}

.btn {
  background-color: #202020;
  color: #F3D4A4;
  width: 100px;
  height: 30px;
  border-radius: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
}

.vip_type_1 {
  background: #f4f5f7;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.vip_type_2 {
  background: url('../../../assets/vip/vip_2.png') no-repeat center/cover;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.vip_type_3 {
  background: url('../../../assets/vip/vip_3.png') no-repeat center/cover;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .info {
    .title_type {
      color: white;
    }

    .des {
      color: white;
    }
  }
}

.vip_type_4 {
  background: url('../../../assets/vip/vip_4.png') no-repeat center/cover;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .info {
    .title_type {
      color: #F3D4A4;
    }

    .des {
      color: white;
    }
  }
}
</style>